// extracted by mini-css-extract-plugin
module.exports = {"container":"not-found_container__LRagC","text-container":"not-found_text-container__0zH8U","header":"not-found_header__0U8gW"};